// directives/has-feature.directive.ts
import { 
  Directive, 
  Input, 
  TemplateRef, 
  ViewContainerRef, 
  OnInit, 
  OnDestroy 
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SubscriptionService, FeatureAccess } from '../services/subscription.service';

@Directive({
  selector: '[hasFeature]'
})
export class HasFeatureDirective implements OnInit, OnDestroy {
  @Input() hasFeature!: keyof FeatureAccess;
  @Input() hasFeatureElse?: TemplateRef<any>;

  private subscription!: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit(): void {
    this.subscription = this.subscriptionService.subscriptionType$.subscribe(() => {
      this.updateView();
    });
    this.updateView();
  }

  private updateView(): void {
    this.viewContainer.clear();
    
    if (this.subscriptionService.hasFeatureAccess(this.hasFeature)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.hasFeatureElse) {
      this.viewContainer.createEmbeddedView(this.hasFeatureElse);
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}